import config from 'config';
import httpTimeout from '../http-timeout';
import wrapUrlWithServerUrl from '../utils/wrap-url-with-server-url';

export const get = <TResponse>(url: string) => {
    return httpTimeout<TResponse>(
        new Request(wrapUrlWithServerUrl(url), {
            ...config.fetch.get,
        }),
    );
};
export default get;
